module.exports = __webpack_public_path__ + "img/aviation.9d9285bd.jpg";